import { render, staticRenderFns } from "./OutSideView.vue?vue&type=template&id=5dc7104c&scoped=true&"
import script from "./OutSideView.vue?vue&type=script&lang=js&"
export * from "./OutSideView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc7104c",
  null
  
)

export default component.exports